<template>
    <div>
        <div class="emailSignature">
            <div class="emailSignature__wrapper">
                <div class="emailSignature-icon">
                    <img src="@/assets/icons/download-icon.svg" alt="">
                </div>
                <div class="emailSignature-title">
                   {{translate('singleEmailSignaturePageTitle')}}
                </div>
                <div class="signature__wrapper">
                        <div class="signature-text__wrapper">
                            <div class="signature-title">{{translate('emailSignature')}}</div>
                            <div class="signature-subtitle">{{translate('emailSignatureSubtitle')}}</div>
                        </div>
                        <input type="hidden" text="fake" id="fake_input" value="fake"/>
                        <div class="signature">
                            <div id="own_signature" ref="ownSignature">
                                <table border="0" cellspacing="0" cellpadding="0" align="center">
                                    <tr>
                                        <td colspan="3" style="font-size:13px; text-align: center; padding-bottom: 4px;">
                                            <b>{{this.$route.query.q}}</b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="right">
                                            <a :href="`${location.origin}/r/rate/` + this.$route.params.guid + '/3'" style="mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;color: #007C89;font-weight: normal;text-decoration: underline;">
                                                <img align="none" alt="Happy" data-file-id="5484253" height="51" src="https://mcusercontent.com/b92973fb598e2f78aeedb5437/images/b8cb1880-0bf5-6b86-5161-2a246b8105cf.png" style="border: 0px;width: 50px;height: 51px;margin: 0px;outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;" width="50">
                                            </a>
                                        </td>
                                        <td width="80" align="center">
                                            <a :href="`${location.origin}/r/rate/` + this.$route.params.guid + '/2'" style="mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;color: #007C89;font-weight: normal;text-decoration: underline;">
                                                <img alt="So-So" data-file-id="5484257" height="51" src="https://mcusercontent.com/b92973fb598e2f78aeedb5437/images/ee813e56-d00e-4ec6-1094-00b27f476708.png" style="border: 0px initial;width: 50px;height: 51px;margin: 0px;outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;" width="50">
                                            </a>
                                        </td>
                                        <td align="left">
                                            <a :href="`${location.origin}/r/rate/` + this.$route.params.guid + '/1'" style="mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;color: #007C89;font-weight: normal;text-decoration: underline;">
                                                <img alt="Sad" data-file-id="5484261" height="51" src="https://mcusercontent.com/b92973fb598e2f78aeedb5437/images/bdbfc823-92b8-6967-0456-f924be344449.png" style="border: 0px initial;width: 50px;height: 51px;margin: 0px;outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;" width="50">
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3" style="font-size: 10px; color: black; text-align: center">
                                            <b>{{translate('emailSignatureClick')}}</b>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="signature-copy__btn" @click="copySignatureBtnClick(getElementById())">
                        {{translate('copy')}}
                    </div>
                <div class="copied" v-if="copiedFlag">
                    {{translate('copied')}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import config from '@/api/config';
export default {
    name: 'emailSignaturePage',

    data() {
        return {
            location: location,
            copiedFlag: false,
        }
    },
    methods: {
        getElementById() {
            return this.$refs.ownSignature.innerHTML
        },
        copySignatureBtnClick(str) {
            this.copiedFlag = true
            setTimeout(()=>{
                this.copiedFlag = false
            }, 1000)
            function listener(e) {
                e.preventDefault();
                e.clipboardData.setData("text/html", str);
                e.clipboardData.setData("text/plain", str);
            }
            document.addEventListener("copy", listener);
            let item = document.getElementById('fake_input')
            let oldType = item.type
            let hidden = oldType == 'hidden'
            if(hidden) item.type = 'text'
            item.select()
            item.setSelectionRange(0, 99999);
            document.execCommand("copy");
            if(hidden) item.type = 'hidden'
            document.removeEventListener("copy", listener);
        },
    }

}
</script>

<style scoped>
    .emailSignature {
        margin-top: 20px;
    }
    .emailSignature-title {
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .emailSignature__wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .signature__wrapper {
        margin-top: 15px;
    }
    .signature-copy__btn {
        color: #FFFFFF !important;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
        border-radius: 6px;
        background-color: #3F405C;
        text-align: center;
        padding: 11px;
        cursor: pointer;
        max-width: 20%;
        width: 100%;
        margin-top: 20px;
    }
    .copied {
        margin-top: 20px;
        background: forestgreen;
        border-radius: 2px;
        -webkit-box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
        box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
        color: #fff;
        display: inline-block;
        font-size: 12px;
        padding: 5px 8px;
        width: auto;
    }
    @media screen and (max-width: 426px) {
        .signature__wrapper {
            flex-direction: column-reverse;
        }
        .signature-copy__btn {
            max-width: 40%;
        }
        .emailSignature-title {
            text-align: center;
            padding-left: 15px;
            padding-right: 15px;
        }
        .signature-text__wrapper {
            margin-top: 15px;
        }
        .signature-subtitle {
            display: block;
            width: 100%;
            padding-left: 15px;
            padding-right: 15px;
        }
        .signature-title {
            padding-bottom: 0;
            width: auto;
        }
        .signature-subtitle {
            text-align: center;
        }
    }
</style>

